import React from "react";
import DashboardToolsUpgradeUserPlanToProModal from "./UpgradeUserPlanToProModal";
import UpgradeUserPlanToStandardModal from "./UpgradeUserPlanToStandardModal";

const DashboardTools: React.FC = () => (
  <>
    <DashboardToolsUpgradeUserPlanToProModal />
    <UpgradeUserPlanToStandardModal />
  </>
);

export default DashboardTools;
